import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { Tooltip } from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import ListSearch from './ListSearch/index';
import styles from './index.less';

const { ListTable } = ListPage;

@connect(({ massRecord }) => {
  return {
    ...massRecord,
  };
})
class DataManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  fetchList = params => {
    const { dispatch } = this.props;
    dispatch({
      type: 'massRecord/fetchList',
      params,
    });
  };

  handleReset = () => {
    const params = {
      page: 1,
      pagesize: 10,
    };
    const { dispatch } = this.props;
    dispatch({
      type: 'massRecord/fetchList',
      params,
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    const { dispatch } = this.props;

    dispatch({
      type: 'massRecord/fetchList',
      params,
    });
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'meetingTitle',
        key: 'meetingTitle',
        width: 330,
        fixed: 'left',
        render: title => (
          <Tooltip placement="top" title={title}>
            <span>{title?.length <= 20 ? title : `${title?.substring(0, 12)}...`}</span>
          </Tooltip>
        ),
      },
      {
        title: '操作人',
        dataIndex: 'initiatorName',
        key: 'initiatorName',
        width: 150,
      },
      {
        title: '群发时间',
        dataIndex: 'meetingStartTime',
        key: 'meetingStartTime',
        render: meetingStartTime => moment(meetingStartTime).format('YYYY.MM.DD HH:mm') || null,
      },
    ];

    return columns;
  };

  render() {
    const { spinProps, pageInfo, list } = this.props;
    const { page, pagesize } = pageInfo;

    const pageProps = {
      spinProps,
      className: styles.root,
    };

    const columns = this.setColumns();

    const tableProps = {
      pageInfo,
      columns,
      list,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.handlePaginationChange,
    };

    const searchProps = {
      page,
      pagesize,
      fetchList: this.fetchList,
      handleReset: this.handleReset,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <ListSearch {...searchProps} />
          <ListTable {...tableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default DataManagement;
